var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgEmptyDocuments118X118 = function SvgEmptyDocuments118X118(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 160 161",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 57.81h45v5H35v-5zM52.5 67.81H80v5H52.5v-5zM35 77.81h35v5H35v-5zM35 87.81h5v5h-5v-5zM45 87.81h5v5h-5v-5zM55 87.81h25v5H55v-5zM35 67.81h12.5v5H35v-5zM75 77.81h50v5H75v-5zM85 87.81h40v5H85v-5zM85 67.81h22.5v5H85v-5zM85 57.81h22.5v5H85v-5z",
    fill: "#577687"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.975 100.236a2.541 2.541 0 00-.1-.726l-10-30a2.535 2.535 0 00-2.375-1.7h-5a2.5 2.5 0 00-.625-1.65l-4.375-5V37.81a2.499 2.499 0 00-2.5-2.5h-2.5v-7.5a2.499 2.499 0 00-2.5-2.5H35a2.5 2.5 0 00-2.5 2.5v7.5H30a2.5 2.5 0 00-2.5 2.5v7.5H25a2.5 2.5 0 00-2.5 2.5v20h-5a2.535 2.535 0 00-2.375 1.7l-10 30c-.068.236-.102.48-.1.726 0 .025-.025.05-.025.075v52.5a2.499 2.499 0 002.5 2.5h145a2.501 2.501 0 002.5-2.5v-52.5c0-.025-.025-.05-.025-.075zM137.5 72.811h3.2l8.325 25H137.5v-25zm-8-7.5H120V54.46l9.5 10.85zm-92-35h85v5h-85v-5zm-5 10h95v15.124l-8.125-9.275a2.448 2.448 0 00-1.875-.85h-85v-5zm-5 10H115v17.5a2.499 2.499 0 002.5 2.5h15v27.5h-105v-47.5zm-8.2 22.5h3.2v25H10.975l8.325-25zm130.7 77.5H10v-47.5h140v47.5z",
    fill: "#577687"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.5 115.311h-65a2.5 2.5 0 00-2.5 2.5v12.5a2.499 2.499 0 002.5 2.5h65a2.501 2.501 0 002.5-2.5v-12.5a2.5 2.5 0 00-2.5-2.5zm-2.5 12.5H50v-7.5h60v7.5z",
    fill: "#577687"
  })));
};

export default SvgEmptyDocuments118X118;